export default __webpack_public_path__ + "static/media/03.28317e1e.jpg";